import { Chip } from '@mui/material';
import { useCurrentRefinements, useRefinementList } from 'react-instantsearch';

export interface ClassificationTagFilterTagsProps {
  attribute: string;
  getItemLabel: (value: string) => string;
}

export default function ClassificationTagFilterTags({ attribute, getItemLabel }: ClassificationTagFilterTagsProps): React.JSX.Element | null {
  const { refine } = useRefinementList({ attribute, limit: 100 });
  const { items } = useCurrentRefinements({ includedAttributes: [attribute] });

  return (items?.[0]?.refinements?.length || 0) > 0 ? (
    <>
      {items[0].refinements.map(({ value }) => (
        <Chip
          key={value}
          label={getItemLabel(value as string)}
          onDelete={() => refine(value as string)}
        />
      ))}
    </>
  ) : null;
}
